<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Reporte Consulta Díaria</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>RP_consulta_diaria</div>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>
              <b-form-group align="left">
                <label>Clínicas</label>
                <v-select
                    v-if="!todas"
                    name="clinica"
                    placeholder="Clinicas"
                    label="strNombre"
                    multiple
                    :reduce="(variable) => variable.idClinica"
                    :options="clinicas"
                    v-model="filtro.idClinicas"
                ></v-select>
                <br />
                <b-form-checkbox
                    id="checkbox-1"
                    v-model="todas"
                    name="checkbox-1"
                    @change="todos()"
                >
                  Todas las clínicas
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group align="left">
                <label>Fecha de inicio</label>
                <b-input-group size="sm" class="mb-2" id="fci" lab>
                  <b-form-datepicker
                      name="nombre"
                      placeholder="Fecha de Inicio"
                      :max="new Date()"
                      v-model="$v.filtro.fechaInicio.$model"
                      :state="validateState('fechaInicio')"
                      labelNoDateSelected="Fecha"
                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group align="left">
                <label>Fecha de fin</label>
                <b-input-group size="sm" class="mb-2" id="fcf" lab>
                  <b-form-datepicker
                      name="nombre"
                      placeholder="Fecha de Fin"
                      :min="filtro.fechaInicio"
                      :max="new Date()"
                      v-model="$v.filtro.fechaFin.$model"
                      :state="validateState('fechaFin')"
                      labelNoDateSelected="Fecha"
                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col></b-col>
            <b-col></b-col>
            <b-col class="text-right">
              <b-button
                  variant="outline-primary"
                  :disabled="loader"
                  @click="obtenerDatos()"
              >
                <span v-if="!loader">Buscar</span>
                <span v-else>
                  <b-spinner small></b-spinner>
                  Buscando...
                </span>
              </b-button>
              <br/>
              <br/>
              <br/>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "../../../components/Header";
import { required } from "vuelidate/lib/validators";
import * as JSZip from "jszip";
import { saveAs } from "file-saver";

export default {
  components: {
    Header,
  },
  name: "ReporteTxPxa",
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loader: false,
      buscado: false,
      show: false,
      filtro: {
        idClinicas: [],
        fechaInicio: null,
        fechaFin: null,
      },

      clinicas: [],
      todas: false
    };
  },
  validations: {
    filtro: {
      fechaInicio: { required },
      fechaFin: { required },
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerClinicas();
    this.filtro.idClinicas = [this.$localStorageService.getIdClinica()];
    this.filtro.fechaInicio = this.$moment().startOf('day').toDate();
    this.filtro.fechaFin = this.$moment().endOf('day').toDate();
  },
  methods: {
    obtenerClinicas() {
      this.$http
          .get(this.$api + "catalogos/listaClinicas")
          .then((respuesta) => {
            this.clinicas = respuesta.data.data;
          });
    },
    saveXLSX(datos) {
      const zip = new JSZip();
      zip.file("ConsultaDiaria.xlsx", datos, { base64: true });
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, "ConsultaDiaria.zip");
      });
    },
    obtenerDatos() {
      this.$v.filtro.$touch();

      if (!this.todas && this.filtro.idClinicas.length == 0) {
        this.$swal({
          icon: "error",
          text: "Debe seleccionar al menos una clínica para realizar la búsqueda",
        });
      } else {
        if (!this.$v.filtro.$invalid) {
          this.loader = true;
          this.buscado = false;

          const envio = {
            idClinicas: this.todas ? [-1] : this.filtro.idClinicas,
            fechaInicio: this.$moment(this.filtro.fechaInicio)
                .utc()
                .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
            fechaFin: this.$moment(this.filtro.fechaFin)
                .add(1, "days")
                .utc()
                .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
            horas: this.$horas(),
          };

          this.$http
              .post(this.$api + "finanzas/reporte/consultaDiaria", envio)
              .then((respuesta) => {
                this.saveXLSX( respuesta.data.data)
              })
              .finally(() => {
                this.loader = false;
                this.buscado = true;
              });
        }
      }
    },
    todos() {
      this.filtro.idClinicas = [];
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.filtro[name];
      return $dirty ? !$error : null;
    },
  },
};
</script>

<style scoped>
.adquisicionSpan {
  cursor: pointer;
  text-decoration: underline;
  color: #00458b;
}

.badgeCss {
  display: flex;
  justify-content: flex-end;
}

.badgeTxt {
  padding: 10px;
  font-size: 15px;
  letter-spacing: 1px;
  font-weight: lighter;
}
</style>
